import { render, staticRenderFns } from "./KeepingSectorGallery.vue?vue&type=template&id=524caf10&scoped=true"
import script from "./KeepingSectorGallery.vue?vue&type=script&lang=js"
export * from "./KeepingSectorGallery.vue?vue&type=script&lang=js"
import style0 from "./KeepingSectorGallery.vue?vue&type=style&index=0&id=524caf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524caf10",
  null
  
)

export default component.exports